import React, { useState } from "react";
import Header from "./Header";
import SiderBar from "./SiderBar";
import useAuth from "../../hooks/useAuth";
import "../../css/main.scss";

const Layout = ({ children }) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const handleMenuToggle = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  // 验证用户登录状态
  useAuth();

  return (
    <div className="main-container">
      <Header
        onMenuToggle={handleMenuToggle}
        isSidebarCollapsed={isSidebarCollapsed}
      />
      <div className="main-content-wrapper">
        <SiderBar isCollapsed={isSidebarCollapsed} />
        <main
          className={`main-content ${
            isSidebarCollapsed ? "sidebar-collapsed" : ""
          }`}
        >
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
